var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListCpuPurpleBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "lqz9ymg95a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.807843 0 0 0 0 0.309804 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "1ksm441nfb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.529412 0 0 0 0 0.576471 0 0 0 0 0.639216 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    filter: "url(#lqz9ymg95a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)",
    filter: "url(#1ksm441nfb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.75 9.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#57B2DA",
    strokeLinejoin: "round",
    x: 2.25,
    y: 2.25,
    width: 12,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#57B2DA",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5V0M10.5 1.5V0M6 16.5V15M10.5 16.5V15"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#57B2DA",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 6h1.5M15 10.5h1.5M0 6h1.5M0 10.5h1.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#57B2DA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6h1.5v1.5H6zM9 6h1.5v1.5H9zM6 9h1.5v1.5H6zM9 9h1.5v1.5H9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListCpuPurpleBig);
export default __webpack_public_path__ + "static/media/ico-vpc-list-cpu-purple-big.c161fcb81b2ae1ef204652575e2224ea.svg";
export { ForwardRef as ReactComponent };